import { Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import { AlarmGroupProvider } from '_/contexts/AlarmGroupContext';
import { AlarmsProvider, useAlarmsContext } from '_/contexts/AlarmsContext';
import React, { ReactElement } from 'react';

function AlarmsContainerContent(): ReactElement {
  const { isLoading } = useAlarmsContext();

  return (
    <AsyncPageContainer isLoading={isLoading}>
      <Outlet />
    </AsyncPageContainer>
  );
}

function AlarmsContainer(): ReactElement {
  return (
    <AlarmGroupProvider>
      <AlarmsProvider>
        <AlarmsContainerContent />
      </AlarmsProvider>
    </AlarmGroupProvider>
  );
}

export default AlarmsContainer;
